<div class="row">
  <div class="col">
    <mat-card appearance="outlined">
      <mat-card-content>
        <h1>{{ 'shoppingCart.receipt.title' | translate }}</h1>

        <div class="section d-flex flex-row-reverse">
          @if ((isAnnualDeclaration  || isEndOfPractice) && (isFormCompleted$ | async)) {
            <button
              mat-button
              (click)="downloadPdf()">{{ 'pdf.printableVersion' | translate:{product: receiptModel?.invoices[0]?.description} }}
              <img class="img-responsive"
                style="margin: 10px;"
                [ngClass]="{'pdfIconRotate': isSummaryDownloading$ | async}"
                src="/assets/images/pdf-icon.png"
                width="30" />
              </button>
            }

            @if (!(isFormCompleted$ | async)) {
              <div class="d-flex justify-content-center align-items-center" style="gap: 20px">
                <div>{{ 'shoppingCart.receipt.pdfGenerating' | translate}}</div>
                <div><mat-spinner diameter="40"></mat-spinner></div>
              </div>
            }
          </div>

          <div class="entete">
            <div class="odq-address">
              <div><span class="font-weight-bold">{{ 'shoppingCart.receipt.ODQAddress.odq' | translate }}</span></div>
              <div><span>{{ 'shoppingCart.receipt.ODQAddress.line1' | translate }}</span></div>
              <div><span>{{ 'shoppingCart.receipt.ODQAddress.line2' | translate }}</span></div>
              <div><span class="font-weight-bold">{{ 'shoppingCart.receipt.fileNumber' | translate }}</span></div>
              <div><span>{{ legalEntityNumber$ | async }} </span></div>
            </div>
            <div class="customer-infos">
              <div><span class="font-weight-bold">{{ 'shoppingCart.receipt.repondant' | translate }}</span></div>
              <div><span>{{ (representativeSubstitute$ | async)?.representative.firstName }} {{(representativeSubstitute$ | async)?.representative?.lastName}}</span></div>
              <div><span class="font-weight-bold">{{ 'shoppingCart.receipt.societe' | translate }}</span></div>
              <div><span>{{ (companyIdentification$ | async)?.name }}</span></div>
              <div><span>{{ (companyIdentification$ | async)?.address?.line1 }}</span></div>
              <div><span>{{ (companyIdentification$ | async)?.address?.line2 }}</span></div>
              <div><span>{{ (companyIdentification$ | async)?.address?.city }} {{ (companyIdentification$ | async)?.address?.provinceCode}} {{ (companyIdentification$ | async)?.address?.postalCode}} {{ (companyIdentification$ | async)?.address?.countryCode}}</span></div>
            </div>
          </div>
          <h3 class="mt-4">
            {{ 'shoppingCart.receipt.subject' | translate:{payment_a: receiptModel?.metadata.year, payment_b: receiptModel?.invoices[0]?.description} }}
          </h3>
          <p
            [innerHtml]="'shoppingCart.receipt.amountCC' | translate:{amount: receiptModel?.amount, cc: receiptModel?.abrCreditCard}">
          </p>

          <div class="section">
            <h4 [innerHtml]="'shoppingCart.receipt.invoice' | translate"></h4>
          </div>
          @for (item of receiptModel?.invoices; track item) {
            <div class="flexbox-container d-flex flex-row justify-content-between"
              >
              <ng-container>
                <div class="flex-items">{{item.description}}</div>
                <div class="flex-items">{{item.totalAmount}}$</div>
              </ng-container>
            </div>
          }
          <div class="section-total d-flex flex-row justify-content-between">
            <div class="flex-items">TOTAL</div>
            <div class="flex-items">{{receiptModel?.amount}}$</div>
          </div>

          <div class="section mt-4">
            <h4 [innerHtml]="'shoppingCart.receipt.transactionReference' | translate"></h4>
          </div>

          <div class="flexbox-container d-flex flex-column">
            <div class="flex-items d-flex flex-row">
              <div class="flex-items"
                style="flex: 0 0 15%">
              {{ 'shoppingCart.receipt.reference.transactionType' | translate }}</div>
              <div class="transaction-detail flex-items"
                style="flex: 0 0 15%">{{ receiptModel?.typeTransactionRefMoneris}}
              </div>
              <div class="flex-items flex-fill"></div>
              <div class="flex-items"
                style="flex: 0 0 15%">{{ 'shoppingCart.receipt.reference.amount' | translate }}
              </div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.amount}}</div>
            </div>
            <div class="flex-items d-flex flex-row">
              <div class="flex-items"
                style="flex: 0 0 15%">{{ 'shoppingCart.receipt.reference.orderId' | translate }}
              </div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.orderId}}</div>
              <div class="flex-items flex-fill"></div>
              <div class="flex-items"
                style="flex: 0 0 15%">
              {{ 'shoppingCart.receipt.reference.approvalCode' | translate }}</div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.numConfirmation}}</div>
            </div>
            <div class="flex-items d-flex flex-row">
              <div class="flex-items"
                style="flex: 0 0 15%">{{ 'shoppingCart.receipt.reference.dateTime' | translate }}
              </div>
              <div class="transaction-detail flex-items"
                style="flex: 0 0 15%">
              {{ receiptModel?.date | date:'yyyy-MM-dd HH:mm:ss'}}</div>
              <div class="flex-items flex-fill"></div>
              <div class="flex-items"
                style="flex: 0 0 15%">
              {{ 'shoppingCart.receipt.reference.responseCode' | translate }}</div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.responseIsoCode}}</div>
            </div>
            <div class="flex-items d-flex flex-row">
              <div class="flex-items"
                style="flex: 0 0 15%">
              {{ 'shoppingCart.receipt.reference.sequenceNumber' | translate }}</div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.sequence}}</div>
            </div>
            <div class="flex-items d-flex flex-row">
              <div class="flex-items"
                style="flex: 0 0 15%">{{ 'shoppingCart.receipt.reference.message' | translate }}
              </div>
              <div class="transaction-detail flex-items"
              style="flex: 0 0 15%">{{ receiptModel?.message}}</div>
            </div>
          </div>

          <div class="section mt-4">
            <h4 [innerHtml]="'shoppingCart.receipt.refundPolicy.title' | translate"></h4>
          </div>
          <div>
            <p>{{ 'shoppingCart.receipt.refundPolicy.detail' | translate }}</p>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
